import type { AlgoliaFacet } from '@jane/search/types';
import type { Store } from '@jane/shared/types';

export const getValidFeelings = (store: Store, feelings: AlgoliaFacet = {}) =>
  Object.fromEntries(
    Object.entries(feelings).filter(
      ([feelings]) =>
        !store.disabled_feeling_and_activity_tags.includes(feelings)
    )
  );
